import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { _CreateProductRowvDOS } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { ProductTaxsCatalogForAddedValue } from "../../../../../../Inventories-Warehouses/Product/ProductTaxes/ProductTaxsCatalogForAddedValue";
import { toast } from "react-toastify";
import { SelectProductVariant } from "../../../../../../Inventories-Warehouses/Product/ProductVariant/SelectProductVariant";
import { ProductionOrderEditor } from "../../../../../../Factoty&Production/ProductionOrder/ProductionOrderEditor";
import { InventoryOutCostFactorySelectfororder } from "./InventoryOutCostFactorySelectfororder";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";


interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const InventoryOutCostFactory = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {
    const { instance, update, handleChange, deleteItemVoid } = useDataBean(_CreateProductRowvDOS);
    const [bean, setBean] = useState<any>({});
    const [beanorden, setBeanorden] = useState<any>({});
    const [lista, setLista] = useState<any>([]);
    const [showFile, setShowFile] = useState<any>(null)
    const [year, setYear] = useState<number>(null)
    const [order, setOrder] = useState<any>(null)
    const [modaledit, setModaledit] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    // const { lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const [addtable, setAddtable] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [definir, setDefinir] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalorden, setModalorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [prevBean, setPrevBean] = useState<any>(null);


    useEffect(() => {
        if (properties.ProductList)
            setLista(properties.ProductList);
    }, [properties])


    const head = [
        { title: 'ID', property: 'IDProduct', visible: true },
        { title: 'Producto', property: 'Description', visible: true },
        { title: 'Código Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Unidad Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Costo', property: 'ProductCost', visible: true, MASK_MONEY },
        { title: 'Cantidad', property: 'Quantity', visible: true, MASK_MONEY },
        { title: 'Cantidad Total', property: 'TotalQuantity', visible: true, MASK_MONEY },
        { title: 'Vr Total', property: 'TotalCost', visible: true, MASK_MONEY },


    ]




    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }

    const createorder = () => {
        setBeanorden({
            IDEmployee: _single.getAccountID()
        });
        setOrder(null)
        setModalorden({ ...modalorden, "view": true, "name": "Agregar" });
    }


    // const createProductRowForOutput = () => {
    //     instance.createProductRowForOutput(bean.IDProduct, bean.IDProductVariant, properties.IDStore, bean.quantity, bean.IDProductionOrder, bean.ProductionOrderDate, bean.IDLot).then(
    //         (rta: any) => {
    //             let x = [...lista];
    //             x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' })
    //             setLista(x)
    //             console.log(rta)
    //             setModal({ ...modal, "view": false, "name": "Agregar" });
    //         }
    //     ).catch(
    //         err => { toast.error(err) }
    //     )
    // }

    const createProductRowForOutput = () => {

        const hashCode = bean.HashCode;
        console.log("Eliminar hash => ", bean);



        instance.createProductRowForOutput(bean.IDProduct, bean.IDStore ?? properties.IDStore, bean.Quantity).then(
            (rta: any) => {

                let x = lista.filter((item) => item.DataBeanProperties.HashCode != hashCode);
                x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' })

                setLista(x);

                setModal({ ...modal, "view": false, "name": "Agregar" });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const createProductRowForOutputByProductLot = () => {
        instance.createProductRowForOutputByProductLot(beanorden.IDLot, properties.IDStore, beanorden.quantity).then(
            (rta: any) => {
                let x = [...lista];
                x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' })
                setLista(x)
                console.log(rta)
                setModalorden({ ...modalorden, "view": false, "name": "Agregar" });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }


    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "view": true }); } },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar por Producto', visible: true, icono: 'ri-git-repository-commits-fill', evento: create },
        { nombre: 'Agregar por Orden de Producción', visible: true, icono: 'ri-inbox-unarchive-fill', evento: createorder }
    ]

    const submitForm = () => {
        // setData(lista)
        // console.log(lista)
        let key = Object.keys(data);
        console.log({ [key[0]]: lista });

        if (setData) {
            setData({ [key[0]]: lista });
        }
    }

    const verlote = () => {
        setAddtable({ ...addtable, "view": true, "name": "" });
    }

    const deleteItem = () => {
        let temp = [];
        lista.forEach(element => {
            console.log(element);
            console.log(bean);

            if (element.DataBeanProperties != bean) {
                temp.push(element)
            }
        });
        setLista(temp)
        setModalC({ ...modalC, "view": false });
    }

    return (
        <div className="row">

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createProductRowForOutput}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProductEditor renderValue={bean.Description} label="Producto" value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Cantidad</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": parseFloat(e.target.value) }) }} />

                            </div>
                        </div>

                    </>
                </Modal>
                <Modal modal={modalorden} updateModal={setModalorden} eventModal={createProductRowForOutputByProductLot}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <strong>Seleccione una Orden*</strong>
                                <ProductionOrderEditor IDOrderProduction={order} returnData={(e) => { setOrder({ ...order, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />
                            </div>
                            {order &&
                                <>
                                    <div className="col-md-12">
                                        <InventoryOutCostFactorySelectfororder idProductionOrder={order.IDProductionOrder} productionOrderDate={order.ProductionOrderDate} idSelector={beanorden.IDLot} onChange={(e) => { setBeanorden({ ...beanorden, "IDLot": e }) }} />
                                    </div>
                                </>
                            }
                            <div className="col-md-12">
                                <label>Cantidad</label>
                                <input type="number" name="quantity" className="form-control" value={beanorden.quantity} onChange={(e) => { setBeanorden({ ...beanorden, "quantity": parseFloat(e.target.value) }) }} />

                            </div>
                        </div>

                    </>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.IDProduct}</strong>
                </ModalConfirm>
                {/* <div className="col-md-12">
                    <Modal modal={addtable} updateModal={setAddtable}>
                        <>
                            <div className="row">
                                <div className="col-md-6">

                                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                                </div>
                                {year &&
                                    <>
                                        <div className="col-md-12">
                                            <InventoryOutCostFactorySelectfororder idProductionOrder={year} productionOrderDate={bean.IDProduct} idSelector={bean.IDLot} onChange={(e) => { setBean({ ...bean, "IDLot": e }) }} />
                                        </div>
                                    </>
                                }

                            </div>
                        </>
                    </Modal>
                </div> */}

            </div>
            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}
                <BasicTable head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />

            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Enviar</BasicButton>
            </div>

            <div className="col-md-12">

            </div>
        </div>
    )
}